import { Box, Button, Grid, useTheme } from "@mui/material";
import React from "react";
import { getDate } from "../../../shared/utils/date";
import { CalendarDayProps } from "../types";
import { isDateDisabled } from "../utils/calendarUtils";

export const CalendarDay: React.FC<CalendarDayProps> = ({
  date,
  inMonth,
  temp,
  minDate,
  maxDate,
  enableFuture,
  disabled,
  isSameDay,
  onSelect,
  onApply,
  onClose,
}) => {
  const theme = useTheme();

  const selected = !disabled && isSameDay(date, temp);
  const isDisabled =
    disabled || isDateDisabled(date, enableFuture, minDate, maxDate);

  const getDateColor = () => {
    if (isDisabled) return theme.colors.text[0];
    if (selected) return theme.palette.common.white;
    if (inMonth) return theme.colors.text[5];

    return theme.colors.text[0];
  };

  const handleClick = () => onSelect(date);

  const handleDoubleClick = () => {
    if (!isDisabled) {
      onSelect(date);
      onApply(date);
      onClose();
    }
  };

  return (
    <Grid item xs={12 / 7}>
      <Box display="flex" justifyContent="center">
        <Button
          disabled={isDisabled}
          onClick={handleClick}
          onDoubleClick={handleDoubleClick}
          sx={{
            minWidth: 36,
            width: 36,
            height: 36,
            borderRadius: "8px",
            color: getDateColor(),
            bgcolor: selected ? theme.colors.primary[5] : "transparent",
            "&:hover": {
              bgcolor: selected
                ? theme.colors.primary[6]
                : theme.colors.secondary[0],
            },
            "&.Mui-disabled": {
              color: theme.colors.text[0],
              opacity: 0.4,
              cursor: "not-allowed",
            },
            fontWeight: 500,
            fontSize: 12,
            p: 0,
          }}
        >
          {getDate(date)}
        </Button>
      </Box>
    </Grid>
  );
};
